export default "__VITE_ASSET__273ab0a6__"